var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-gallery scrollable only-y"},[_c('title-component'),_c('content-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }